import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Header";

export default function Footer() {
  const cols = [
    { h: "Explore", items: ["Buy", "Sell", "Commercial", "Residential", "Plots", "Apartments"] },
    { h: "Trust", items: ["Verified Properties", "Property Passport", "Verification Policy", "Disclaimer"] },
    { h: "Company", items: ["About LOOP", "Contact", "Privacy", "Terms"] },
  ];
  return (
    <footer className="bg-[#070C1E] border-t border-white/10 pb-24 md:pb-10 pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div>
            <Logo />
            <p className="mt-4 text-sm text-slate-400 max-w-xs">
              LOOP Properties. Real estate, verified. Buy with information, not just photos.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.h}>
              <h4 className="text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C5A059] mb-4">{c.h}</h4>
              <ul className="space-y-2.5">
                {c.items.map((i) => (
                  <li key={i}>
                    <Link to="/search" className="text-sm text-slate-400 hover:text-white transition-colors">{i}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 text-xs text-slate-500 leading-relaxed">
          Verification status reflects information reviewed by LOOP and/or relevant professionals. Buyers should
          independently verify documents and obtain appropriate legal, financial and technical advice before entering
          into a transaction.
          <div className="mt-3">© 2026 LOOP Properties. Now across India — Mumbai · Delhi · Bengaluru · Hyderabad · Pune · Bhubaneswar & more.</div>
        </div>
      </div>
    </footer>
  );
}
